<template>
  <div class="container">
    <div class="row">
    <div class="col-md-3 col-sm-12 left" style="
    background: rgb(255, 255, 255);-webkit-box-shadow: 0 0 18px 0 rgba(222, 222, 222, 1);box-shadow: 0 0 18px 0 rgba(222, 222, 222, 1); min-height:100vh; height: auto !important; position:relative
    ">
    <div class="logo-part">
        <router-link to="/"><img src="https://www.customvarsityapparel.com.au/customize/img/logo-mini.png" width="100px"></router-link>
    </div>
    <div class="side-control">
    <div class="col-sm-12 col-md-12" id="sidemenu" style="padding:0; height:72vh; overflow-Y: scroll; overflow-X: hidden">
       <JacketSideMenu />
    </div>  
    </div>
    <div class="col-md-12" style="padding: 0;  position:relative;">    
      <div style="padding:10px;">© Custom Varsity Apparel - 2020 | All Rights Reserved,<br>Developed by  
          <a href="https://supportsoft.com.au" target="_blank"> Supportsoft Pvt ltd</a>
      </div>
    </div>
    </div> 
    <div class="col-md-8 col-sm-12"  style="min-height:100vh; height: auto !important">
      <div id="previewImage"><img src=""></div>
      <div id="download"></div>
      <div v-show="common_jacket">
        <Jacket v-show="common_front"/>
        <JacketBack v-show="common_back"/>  
        <JacketLeft v-show="common_left"/>  
        <JacketRight v-show="common_right"/>  
      </div>
      <div v-show="hoodie_jacket">
        <HoodieJacket v-show="hoodie_front"/>
        <HoodieJacketBack v-show="hoodie_back"/>  
        <HoodieJacketLeft v-show="hoodie_left"/>  
        <HoodieJacketRight v-show="hoodie_right"/>  
      </div>
      <Switches ref="switch"/>
  </div>
    <div class="clearfix"></div>
    </div>
  </div>
</template>

<script>
import JacketSideMenu from '@/components/JacketSideMenu.vue'
import Jacket from '@/components/Jacket.vue'
import JacketBack from '@/components/JacketBack.vue'
import JacketLeft from '@/components/JacketLeft.vue'
import JacketRight from '@/components/JacketRight.vue'

import HoodieJacket from '@/components/HoodieJacket.vue'
import HoodieJacketBack from '@/components/HoodieJacketBack.vue'
import HoodieJacketLeft from '@/components/HoodieJacketLeft.vue'
import HoodieJacketRight from '@/components/HoodieJacketRight.vue'

import Switches from '@/components/Switches.vue'

import { mapGetters } from 'vuex';
export default {
  name: 'home',
  components:{
    JacketSideMenu,
    Jacket,
    JacketBack,
    JacketLeft,
    JacketRight,
    HoodieJacket,
    HoodieJacketBack,
    HoodieJacketLeft,
    HoodieJacketRight,
    Switches
  },
  created() {
    this.storeSession(),
    this.$store.watch( getters => getters.common_jacket),
    this.$store.watch( getters => getters.common_front),
    this.$store.watch( getters => getters.common_back),
    this.$store.watch( getters => getters.common_left),
    this.$store.watch( getters => getters.common_right),
    this.$store.watch( getters => getters.hoodie_jacket),
    this.$store.watch( getters => getters.hoodie_front),
    this.$store.watch( getters => getters.hoodie_back),
    this.$store.watch( getters => getters.hoodie_left),
    this.$store.watch( getters => getters.hoodie_right)
    
  },
  computed: {
    ...mapGetters({
      common_jacket: 'common_jacket',
      common_front: 'common_front',
      common_back: 'common_back',
      common_left: 'common_left',
      common_right: 'common_right',
      hoodie_jacket: 'hoodie_jacket',
      hoodie_front: 'hoodie_front',
      hoodie_back: 'hoodie_back',
      hoodie_left: 'hoodie_left',
      hoodie_right: 'hoodie_right',
      
    })
  },
  methods: {
    storeSession(){
      if(this.$session.exists() == false)
      {
        let user_key = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 34);
        console.log(user_key)
        this.$session.set('user_key', user_key)
        sessionStorage.setItem('user_key', user_key)
      }
    }
  },
}
</script>
<style scoped>
.btn:focus,.btn:active {
    outline: none !important;
    box-shadow: none;
    }
    .side-control{
        background: #fff;
        position: relative;
    }
   
    /* fancy scroll */
::-webkit-scrollbar {
  width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey; 
  border-radius: 10px;
}
 
/* Handle */
::-webkit-scrollbar-thumb {
  background: #b82a2f; 
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #b30000; 
}
</style>

